import React from "react";
import ResetPassword from "../components/auth/ResetPassword";

export default function PasswordResetPage() {
  return <ResetPassword />;
}
